export function thimEkitsSetCookie( cname, cvalue, exdays ) {
	const d = new Date();
	d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
	const expires = 'expires=' + d.toUTCString();
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function thimEkitsGetCookie( cname ) {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent( document.cookie );
	const ca = decodedCookie.split( ';' );
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt( 0 ) == ' ') {
			c = c.substring( 1 );
		}
		if (c.indexOf( name ) == 0) {
			return c.substring( name.length, c.length );
		}
	}
	return '';
}

export function setVariable( element, variable, value ) {
	element.style.setProperty( variable, value );
}

export function thimClick(element, iconBtn, inner) {
    const wrappers = document.querySelectorAll(element);
    
    if (!wrappers.length) {
        return;
    }

    wrappers.forEach((wrapper) => {
        const clickBtn = wrapper.querySelector(iconBtn);
        const class_open = element.replace('.', '') + '__open';
        const closeElement = wrapper.querySelector(element + '__close');

        const isOpenElement = () => wrapper.classList.contains(class_open);

        const showElement = () => {
            if (!isOpenElement()) {
                wrapper.classList.add(class_open);
            }
        };

        const hideElement = () => {
            if (isOpenElement()) {
                wrapper.classList.remove(class_open);
            }
        };

        const toggleElement = () => {
            if (isOpenElement()) {
                hideElement();
            } else {
                showElement();
            }
        };

        const onKeyDown = (e) => {
            if (e.keyCode === 27) {
                hideElement();
            }
        };

        if (clickBtn) {
            clickBtn.onclick = function (e) {
                e.preventDefault();
                toggleElement();
            };
        }

        document.addEventListener('click', (e) => {
            if (!isOpenElement()) {
                return;
            }

            const target = e.target;

            if (target.closest(inner) || target.closest(iconBtn)) {
                return;
            }

            hideElement();
        });

        if (closeElement) {
            closeElement.addEventListener('click', (e) => {
                e.preventDefault();
                hideElement();
            });
        }

        document.addEventListener('keydown', onKeyDown, false);
    });
}